import WebpackBackend from '@sas/nova-commons/locale/WebpackBackend';
import { novaLocaleToFileExtension, unsupportedBundleMessage, } from '@sas/nova-commons/locale/npmbackends/util';
export class VAReactCoreEuaWebpackBackend extends WebpackBackend {
    async import(language, bundleName) {
        if (bundleName === 'vaeua-gui-eua') {
            const bundle = await import(`@sas/reacteua-vaeua/vaeua-gui-eua${novaLocaleToFileExtension(language)}.properties`);
            return bundle.default;
        }
        throw unsupportedBundleMessage(language, bundleName);
    }
}
